<div *ngIf="formArray != null" class="grouped-products-container">
  <div class="search-container">
    <input class="search-bar" type="text" nz-input [(ngModel)]="searchTerm" (ngModelChange)="searchChange()"
      placeholder="Search by SKU or Name" />
    <span nz-icon nzType="search" nzTheme="outline" class="search-icon"></span>
  </div>
  <button nz-button nzType="primary" (click)="openProductSelector()">{{'Add products' | translate }}</button>

  <!-- 
    <div class="search-bar">

      <input type="text" nz-input ngModel #searchInput (blur)="onSearchChange($event, searchInput)"
        (keypress)="onSearchChange($event, searchInput)" placeholder="Search by sku or name..." />
    </div>
    -->
  <ng-container>
    <!-- <legend>Grouped Product</legend> -->
    <div class="grouped-product-header">
      <span nz-icon nzType="appstore" nzTheme="outline"></span>
      <h2>{{'Grouped Product' | translate }}</h2>
    </div>

    <div *ngIf="displayedProducts.length === 0">
      <nz-alert nzType="warning" [nzDescription]="'No found Products!' | translate" nzShowIcon></nz-alert>

    </div>
    <nz-table
 
    [nzBordered]="true"
    [nzData]="displayedProducts"
    [nzShowPagination]="true"
    [nzShowSizeChanger]="true" 
    [nzTotal]="displayedProducts.length"
    [nzPageIndex]="tableParams.index"
    [nzPageSize]="tableParams.size"
    (nzPageIndexChange)="onPageChange($event)"
     #productsTable
>
      <thead class="header-table">
        <tr>
          <th nzWidth="50px">#</th>
          <th nzWidth="150px">{{'Name' | translate }}</th>
          <th nzWidth="150px">{{'Sku' | translate }}</th>
          <th nzWidth="100px"> {{'Position' | translate }}</th>
          <th nzWidth="100px">{{'Default Quantity' | translate }}</th>
          <th nzWidth="50px">{{'Actions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of productsTable.data;let i = index">
          <td> {{ (tableParams.index - 1) * tableParams.size + (i + 1) }}</td>
          <td>{{ product.name }}</td>
          <td>{{ product.sku }}</td>
          <td>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value'  | translate">
              <nz-input-number [(ngModel)]="product.position" id="position" [nzStep]="1" [nzSize]="'default'"
                (ngModelChange)="updateFormArrayValue(i, 'position', $event)"></nz-input-number>
            </nz-form-control>
          </td>
          <td>
            <nz-form-control [nzSm]="24" [nzMd]="12" [nzErrorTip]="'Please insert the value'  | translate">
              <nz-input-number [(ngModel)]="product.defaultQuantity" id="position" [nzStep]="1" [nzSize]="'default'"
                (ngModelChange)="updateFormArrayValue(i, 'defaultQuantity', $event)"></nz-input-number>
            </nz-form-control>
          </td>
          <td>
            <span class="delete" nz-icon nzType="delete" nzTheme="outline"
              (click)="deleteProduct(product.childProductId)">

            </span>
          </td>
        </tr>


      </tbody>
    </nz-table>

    <!-- <button nz-button nzType="primary" (click)="openProductSelector()">Add products</button> -->
  </ng-container>
</div>

<app-product-selector [productId]="productId" [savedFilters]="savedFilters"
  (filtersChanged)="handleFilterChanges($event)" (productsSelected)="handleProductSelection($event)"
  (getProducts)="refreshDrawerProducts()" [listColumns]="listColumns" [productsPayload]="drawerPayload"
  [preSelectedProducts]="selectedProductsOld">
</app-product-selector>


<!-- <ng-template #customNoDataTemplate>
  <nz-alert
  nzType="warning"
  nzDescription="No found Products!"
  nzShowIcon></nz-alert>
</ng-template> -->